import EventTile from './EventTile';
export type { EventTileProps } from './EventTile.types';

export default EventTile;
